import { render, staticRenderFns } from "./VideoContent.vue?vue&type=template&id=65036fe8&"
import script from "./VideoContent.vue?vue&type=script&lang=js&"
export * from "./VideoContent.vue?vue&type=script&lang=js&"
import style0 from "./VideoContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65036fe8')) {
      api.createRecord('65036fe8', component.options)
    } else {
      api.reload('65036fe8', component.options)
    }
    module.hot.accept("./VideoContent.vue?vue&type=template&id=65036fe8&", function () {
      api.rerender('65036fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/Card/VideoContent.vue"
export default component.exports